import "@patternfly/pfe-health-index/dist/pfe-health-index";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Env from "./utils/env";

if (Env.getEnvName() === Env.EnvNames.PROD) {
	Sentry.init({
		dsn: "https://f9471121e687a66232ec6caeebeaa410@o490301.ingest.us.sentry.io/4511301374246912",
		environment: "production",
		...(import.meta.env.VITE_SPA_VERSION && {
			release: `pps-001-rhc-partner-portal@${import.meta.env.VITE_SPA_VERSION}`,
		}),
		tracesSampleRate: 0.5,
	});
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
